import { Component, OnInit } from '@angular/core';
import Swal from 'sweetalert2'
import { AuthenticationService } from "../services/authentication.service";
import { ActivatedRoute, Router } from "@angular/router";
import { NgxUiLoaderService, SPINNER } from 'ngx-ui-loader';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

interface marker {
  lat: number;
  lng: number;
  label?: string;
  draggable: boolean;
  mouseMarkerOver?: string;
}
@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.css']
})
// export class ProfileComponent implements OnInit {
//  public user:any;
//  public userImage:any;
//  showSpinner: Boolean = true;
//  spinnerType = SPINNER.circle;
//  marArr: any= [];
//  modalReference: any = null;
//  modalReference1: any = null;
//   constructor(public router: Router, private modalService: NgbModal, private route: ActivatedRoute, private ngxService: NgxUiLoaderService, public authenticationService: AuthenticationService) { }

//   ngOnInit(): void {
//     this.user = this.authenticationService.currentUserValue;
//     // this.userImage = this.user.photo;
//     localStorage.removeItem('email')
//     this.route.params.subscribe(params => {
//       if(params.businessUserName){
//         this.ngxService.start();
//         this.getUserProfile(params.businessUserName)
//       }
//     })
//   }

//   private redirectHome(): void {
//     // Logged-in users go to dashboard; public users go to login (app "home")
//     const token = localStorage.getItem('merchant_token');
//     this.router.navigate([token ? '/dashboard' : '/login'], { replaceUrl: true });
//   }

//   public getUserProfile(businessUserName): void {
//     this.authenticationService.getProfileByUsername(businessUserName).subscribe(
//       (response:any) => {
//         const data = response?.data;
//         if (!data || !data.registerLocation?.coordinates?.length) {
//           this.ngxService.stop();
//           this.redirectHome();
//           return;
//         }

//         this.user = data;
//         this.marArr = [];
//         this.marArr.push({
//           lng: data.registerLocation.coordinates[0],
//           lat: data.registerLocation.coordinates[1],
//           label: 1,
//           streetAddress: data.address?.streetAddress,
//           city: data.address?.city,
//           state: data.address?.state,
//           country: data.address?.country,
//           googleAddress: data.address?.googleAddress,
//           draggable: false,
//         });
//         // Swal.fire()
//         this.ngxService.stop();
//       },
//       error => {
//         if (error) {
//           this.ngxService.stop();
//           // If username is invalid / merchant not found, redirect instead of showing broken page
//           this.redirectHome();
//         }
//       }
//     );
//   }

//   markerDragEnd(m: marker, $event: MouseEvent) {}
//   markers: marker[] = this.marArr;

//   setUrl(photo: string) {
//     if (photo != null) {
//       const [baseUrl, imgUrl] = photo.split('uploads');
//       return `https://services.ravel.faith/uploads/${imgUrl}`;
//       // return `http://localhost:9000/uploads${imgUrl}`
//     }
//   }


//   convertToIST(dateString: string): string {
//     const date = new Date(dateString);

//     // IST is 5 hours and 30 minutes ahead of UTC
//     const istOffset = 5.5 * 60 * 60 * 1000;
//     const istDate = new Date(date.getTime() + istOffset);

//     // Format the date as needed
//     const formattedDate = istDate.toLocaleString('en-IN', {
//       hour: '2-digit',
//       minute: '2-digit',
//       second: '2-digit',
//     });

//     return formattedDate;
//   }

//   openMapForDirections(coordinates: number[]) {
//     const [lat, lng] = coordinates;
//     const url = `https://www.google.com/maps/dir/?api=1&destination=${lat},${lng}`;
//     window.open(url, '_blank');
//   }

//   copyCurrentURL() {
//     const url = window.location.href;  // Get current page URL
//     navigator.clipboard.writeText(url).then(() => {
//       alert('URL copied to clipboard!');  // Success message
//     }).catch(err => {
//       console.error('Error copying URL: ', err);
//     });
//   }

//   openProfileSelectModal(content: any) {
//     this.modalReference1 = this.modalService.open(content, { centered: true, backdrop: 'static', keyboard: false });
//   }

//   redirectTo() {
//     this.modalReference1.close();
//     this.router.navigate(['/login']); 
//   }

// }

export class ProfileComponent implements OnInit {
  public user: any;
  public userImage: any;
  showSpinner: Boolean = true;
  spinnerType = SPINNER.circle;
  marArr: any = [];
  modalReference: any = null;
  modalReference1: any = null;
  constructor(public router: Router, private modalService: NgbModal, private route: ActivatedRoute, private ngxService: NgxUiLoaderService, public authenticationService: AuthenticationService) { }

  ngOnInit(): void {
    this.user = this.authenticationService.currentUserValue;
    // this.userImage = this.user.photo;
    localStorage.removeItem('email')
    this.route.params.subscribe(params => {
      if (params.businessUserName) {
        this.ngxService.start();
        this.getUserProfile(params.businessUserName)
      }
    })
  }

  private redirectHome(): void {
    // Logged-in users go to dashboard; public users go to login (app "home")
    const token = localStorage.getItem('merchant_token');
    this.router.navigate([token ? '/dashboard' : '/login'], { replaceUrl: true });
  }

  public getUserProfile(businessUserName): void {
    this.authenticationService.getProfileByUsername(businessUserName).subscribe(
      (response: any) => {
        const data = response?.data;
        if (!data || !data.registerLocation?.coordinates?.length) {
          this.ngxService.stop();
          this.redirectHome();
          return;
        }

        this.user = data;
        this.marArr = [];
        this.marArr.push({
          lng: data.registerLocation.coordinates[0],
          lat: data.registerLocation.coordinates[1],
          label: 1,
          streetAddress: data.address?.streetAddress,
          city: data.address?.city,
          state: data.address?.state,
          country: data.address?.country,
          googleAddress: data.address?.googleAddress,
          draggable: false,
        });

        // ---- NEW: analytics tracking (profile view + passive view-counters) ----
        this.trackProfileVisitAndViews(data);
        // ---- NEW ends ----

        this.ngxService.stop();
      },
      error => {
        if (error) {
          this.ngxService.stop();
          this.redirectHome();
        }
      }
    );
  }

  // ---- NEW: analytics helpers ----

  private trackProfileVisitAndViews(data: any): void {
    if (!data?._id) return;

    // profile view (always fires once per page load)
    this.authenticationService.trackAnalytics(data._id, 'profileViews').subscribe();

    // photo gallery — count as "viewed" if merchant has gallery images and page is showing them
    if (data.imageGallery && data.imageGallery.length > 0) {
      this.authenticationService.trackAnalytics(data._id, 'photoGalleryViews').subscribe();
    }

    // member discount — count as "viewed" if merchant has a discount configured
    if (data.perpetualAdd?.description) {
      this.authenticationService.trackAnalytics(data._id, 'memberDiscountViews').subscribe();
    }
  }

  trackClick(field: string, platform?: string): void {
    if (!this.user?._id) return;
    this.authenticationService.trackAnalytics(this.user._id, field, platform).subscribe();
  }

  // ---- NEW ends ----

  markerDragEnd(m: marker, $event: MouseEvent) { }
  markers: marker[] = this.marArr;

  setUrl(photo: string) {
    if (photo != null) {
      const [baseUrl, imgUrl] = photo.split('uploads');
      return `https://services.ravel.faith/uploads/${imgUrl}`;
      // return `http://localhost:9000/uploads${imgUrl}`
    }
  }


  convertToIST(dateString: string): string {
    const date = new Date(dateString);

    // IST is 5 hours and 30 minutes ahead of UTC
    const istOffset = 5.5 * 60 * 60 * 1000;
    const istDate = new Date(date.getTime() + istOffset);

    // Format the date as needed
    const formattedDate = istDate.toLocaleString('en-IN', {
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
    });

    return formattedDate;
  }

  openMapForDirections(coordinates: number[]) {
    const [lat, lng] = coordinates;
    const url = `https://www.google.com/maps/dir/?api=1&destination=${lat},${lng}`;
    window.open(url, '_blank');

    // ---- NEW ----
    this.trackClick('directionsClicks');
    // ---- NEW ends ----
  }

  copyCurrentURL() {
    const url = window.location.href;  // Get current page URL
    navigator.clipboard.writeText(url).then(() => {
      alert('URL copied to clipboard!');  // Success message
    }).catch(err => {
      console.error('Error copying URL: ', err);
    });
  }

  openProfileSelectModal(content: any) {
    this.modalReference1 = this.modalService.open(content, { centered: true, backdrop: 'static', keyboard: false });
  }

  redirectTo() {
    this.modalReference1.close();
    this.router.navigate(['/login']);
  }

}
